'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import OwnershipFormsController from './controller/ownershipForms';
import OwnershipFormSelectController from './controller/ownershipFormSelect';
import OwnershipFormModalCreateController from './controller/ownershipFormModalCreate';
import OwnershipFormModalSelectController from './controller/ownershipFormModalSelect';
import OwnershipFormTableDirective from './directive/ownershipFormTable';
import OwnershipFormService from './service/ownershipForm';

export default angular.module('investmentProject.ownershipForm', [])
    .controller('OwnershipFormsController', OwnershipFormsController)
    .controller('OwnershipFormModalCreateController', OwnershipFormModalCreateController)
    .controller('OwnershipFormModalSelectController', OwnershipFormModalSelectController)
    .controller('OwnershipFormSelectController', OwnershipFormSelectController)
    .directive('ownershipFormTable', OwnershipFormTableDirective)
    .factory('OwnershipFormService', OwnershipFormService)
    .name;
